<script>
    // @ is an alias to /src
    import axios from 'axios'
    import sjData from '@/sjUtilData'


    export default {
        name: 'QuarterlyAwardsSummary',
        data() {
            return {
                mode: "loading",
                quartersList: [],
                newQuartersList: [],
                lastQuarterDesc: null,

                monthList: [],
                selMonthFrom: null,
                selMonthTo: null,
                selQuarter: null,
                awardStatus: 'W',
                report: [],
                isLoading: false,
                hasRunOnce: false,



                fNewQuarter: {
                    form: { quarterNum: '', quarterYear: '', dateFrom: '', dateTo: '' }
                },

            }
        },
        computed: {
            member() {
                return this.$store.state.memberStore.member
            },

            isLoggedIn() {
                return this.$store.state.isLoggedIn
            },

            isPageReady() {
                return this.$store.state.isLoggedIn && this.$store.state.memberStore.isMemberLoaded;
            },
        },

        created() {
            let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            const result = [];
            let curYear = new Date().getFullYear();
            let curMonth = new Date().getMonth();

            for (let y = curYear; y >= curYear - 3; y--) {
                let mStart = y == curYear ? curMonth : 11;
                for (let m = mStart; m >= 0; m--) {
                    let t = months[m] + ' ' + y;
                    if (result.length === 0) this.selMonthFrom = t;
                    if (result.length === 0) this.selMonthTo = t;
                    result.push({ value: t, text: t });
                }
            }
            this.monthList = result;
        },
        mounted() {
            this.loadQuarters();

            //axios.post('/api/member/memberget', {})
            //	.then(({ data }) => {
            //		//this.roles = data.roles;
            //		//this.noms = new sjData(data.noms).data;
            //		//this.displayPart = 1;
            //	})
            //	.catch((error) => {
            //		if (error) {
            //			this.msgBox(error.response.data.message);
            //		}
            //	})
        },
        watch: {
            isPageReady() { //newWidth, oldWidth
                this.onPageReady();
            },
            selMonthFrom() {
                this.report = [];
            },
            selMonthTo() {
                this.report = [];
            }
        },

        methods: {
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },

            onPageReady() {
                this.loadQuarters();
            },

            loadQuarters() {
                this.mode = "loading";
                this.quartersList = [];
                this.report = [];
                this.selQuarter = null;
                axios.post('/api/nom/quartersList', {})
                    .then(({ data }) => {
                        const d = new sjData(data.quarters).data;
                        
                        if (d.length !==0) {
                            const qlist = [];
                            d.forEach((e) => qlist.push( { value: e, text: 'Q' + e.description } ));
                            this.quartersList = qlist;
                            this.selQuarter = qlist[0].value;
                        }

                        this.mode = "";
                    })
                    .catch((error) => {
                        if (error) {
                            this.msgBox('An unexpected error occurred ' + error);
                        }
                    });

            },

            showNewQuarterForm() {
                this.hasRunOnce = false;
                this.report = [];

                let quarterNum = 3;
                let quarterYear = 2024;
                this.newQuartersList = [];
                this.formSetState(this.fNewQuarter, true, true);//formObj, resetState, resetForm

                if (this.quartersList.length !== 0) {
                    const lastQuarter = this.quartersList[0].value;
                    quarterNum = lastQuarter.quarterNum;
                    quarterYear = lastQuarter.quarterYear;
                    this.lastQuarterDesc = 'Q' + quarterNum + " / " + quarterYear;
                } else {
                    this.lastQuarterDesc = "(none)";
                }

                //Generate new years
                for (let i = 0; i <= 2; i++) {
                    quarterNum++;;

                    if (quarterNum > 4) {
                        quarterNum = 1;
                        quarterYear++;
                    }

                    let v = { value: { num: quarterNum, year: quarterYear }, text: 'Q' + quarterNum + " / " + quarterYear };
                    this.newQuartersList.push(v);
                }
                this.selQuarter = this.newQuartersList[0].value;

                this.mode = "newQuarter"
            },

            createNewQuarter() {
                axios.post('/api/nom/addNewQuarter', { quarterNum: this.selQuarter.num, quarterYear: this.selQuarter.year, dateFrom: this.selMonthFrom, dateTo: this.selMonthTo })
                .then(({ data }) => {
                    this.loadQuarters();
                })
                .catch((error) => {
                    if (error) {
                        this.msgBox(error.response.data.message);
                    }
                })
            },

            loadNominations() {
                this.isLoading = true;
                this.report = [];
                axios.post('/api/report/quarterlyawards', { selMonthFrom: this.selMonthFrom, selMonthTo: this.selMonthTo, awardStatus: this.awardStatus })
                    .then(({ data }) => {
                        this.isLoading = false;
                        this.hasRunOnce = true;
                        this.report = new sjData(data.report).data;
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        if (error) {
                            this.msgBox(error.response.data.message);
                        }
                    })
            },


            loadSummary() {
                this.isLoading = true;
                this.report = [];
                axios.post('/api/nom/QuarterlyAwardsSummaryReport', { quarterId: this.selQuarter.nexusNomQuarterId  })
                    .then(({ data }) => {
                        this.isLoading = false;
                        this.hasRunOnce = true;
                        let r = new sjData(data.report).data;
                        let l = r.length;
                        
                        for (let idx=0; idx<l; idx++) {
                            r[idx].detail = null;
                        }
                        
                        this.report = r;

                    })
                    .catch((error) => {
                        this.isLoading = false;
                        if (error) {
                            this.msgBox(error.response.data.message);
                        }
                    })
            },

            loadDetails(f) {
                axios.post('/api/nom/QuarterlyAwardsSummaryDetails', { nexusNomQuarterSummaryId : f.nexusNomQuarterSummaryId })
                .then(({ data }) => {
                    f.detail = new sjData(data.report).data;
                })
                .catch((error) => {
                    this.isLoading = false;
                    if (error) {
                        this.msgBox(error.response.data.message);
                    }
                })
            },










            exportToCSV() {
                let fx = function (val, fn) {
                    if (typeof fn === "undefined") fn = '';
                    let isNum = (fn === 'num' || typeof val === "number") && !isNaN(val);
                    try {
                        if (isNum) {
                            return val;
                        } else {
                            let s = val.sjReplaceAll("\r\n", " ~ ")
                                .sjReplaceAll("\r", " ~ ")
                                .sjReplaceAll("\n", " ~ ")
                                .sjReplaceAll("\t", "   ")
                                .trim();

                            //ph - phone number - split after 3 chars
                            if (fn == "ph" && s.length > 9) {
                                if (s.substr(0, 1) === "0") {
                                    s = s.sjReplaceAll(' ', '').sjReplaceAll('-', '').sjReplaceAll('(', '').sjReplaceAll(')', '').substr(0, 3) + " " + s.substr(3, 3) + " " + s.substr(6, 4);
                                } else {
                                    s = "'" + s;
                                }
                            }

                            //https://blog.zsec.uk/csv-dangers-mitigations/
                            if (s.indexOf("@") === 1 || s.indexOf("+") === 1 || s.indexOf("-") === 1 || s.indexOf("=") === 1 || s.indexOf("|") === 1 || s.indexOf("%") === 1) {
                                s = "'" + s.sjReplaceAll("|", "\\|");
                            }

                            s = "\"" + s.sjReplaceAll("\"", "\"\"") + "\"";
                            return s;
                        }
                    } catch {
                        return 'Error';
                    }
                }

                let csv = 'Ref,Nominee ID,Nominee Name,Nominee Division,Nominations Count,Nominated For,Average Rating,Reason,Quarterly Motivation\r\n';

                for (var n = 0; n < this.report.length; n++) {
                    let f = this.report[n];
                    //debugger;
                    csv += f.ref + ','
                        + fx(f.nomineeMemberNumber) + ','
                        + fx(f.nomineeMember) + ','
                        + fx(f.nomineeDivision) + ','
                        + fx(f.totalNominations) + ','
                        + fx(f.nomCatCounts) + ','
                        + fx(f.reviewRatingAve) + ','
                        + fx(f.reasonSummary) + ','
                        + fx(f.quarterlyMotivationSummary) + '\r\n';
                }

                var pom = document.createElement('a');
                pom.href = URL.createObjectURL(new Blob(['\uFEFF', csv], { type: 'text/csv;charset=utf-8;' }));
                pom.setAttribute('download', 'report.csv');
                pom.click();
            },
            windowPrint() {
                window.print();
            },
            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            }


        }

    }
</script>
<template v-if="isLoggedIn">
    <div class="container-fluid page">

        <section v-if="mode==='IGNOREnewQuarter'">
            <div class="card card-default" style="min-width:420px">
                <div class="card-header">
                    <div class="row">
                        <div class="col-sm-6 font-weight-bold">
                            <h5>Quarterly Award Summary - Create New Quarter</h5>
                        </div>

                        <div class="col-sm-3 text-right">
                            <b-button class="d-print-none" size="sm" @click.prevent="exportToCSV" :disabled="report.length==0">Back</b-button>
                        </div>
                    </div>

                </div>
                <div class="card-body">

                    <div class="col-sm-3">
                        <b-form @submit.prevent="onSubmit" novalidate>
                            <div class="mb-3">
                                Define a new quarter for the Quarterly Awards.
                            </div>
                            <b-form-group id="quarterYearGrp" label-for="quarterYearTxt" label="Quarter:" :invalid-feedback="fNewQuarter.errors.quarterYear" class="mb-3">
                                <b-form-select :options="newQuartersList" v-model="fNewQuarter.form.quarterYear" :state="fNewQuarter.state.quarterYear" />
                            </b-form-group>

                            <div class="mb-3">
                                Select a date range of the nominations to add to this quarter.
                            </div>

                            <b-form-group id="dateFromGrp" label-for="dateFromTxt" label="From Date:" :invalid-feedback="fNewQuarter.errors.dateFrom">
                                <b-form-select :options="monthList" v-model="fNewQuarter.form.dateFrom" :state="fNewQuarter.state.dateFrom" />
                            </b-form-group>


                            <b-form-group id="dateToGrp" label-for="dateToTxt" label="To Date:" :invalid-feedback="fNewQuarter.errors.dateTo">
                                <b-form-select :options="monthList" v-model="fNewQuarter.form.dateTo" :state="fNewQuarter.state.dateTo" />
                            </b-form-group>

                            <div class="text-right"><b-button type="submit" variant="primary">Create New Quarter</b-button></div>
                        </b-form>
                    </div>


                </div>
            </div>
        </section>

        <!-- ************************************************************************************************************************************ -->
        <!-- newQuarter -->

        <section v-if="mode==='newQuarter'">
            <div class="card card-default" style="min-width:420px">
                <div class="card-header">
                    <div class="row">
                        <div class="col-sm-6 font-weight-bold">
                            <h5>Quarterly Award Summary - Define a new Quarter</h5>
                        </div>

                        <div class="col-sm-3">

                        </div>
                        <div class="col-sm-3 text-right">
                            <b-button class="d-print-none" size="sm" @click.prevent="loadQuarters">Back</b-button>
                        </div>
                    </div>

                </div>
                <div class="card-body">
                    <b-form @submit.prevent="createNewQuarter" novalidate>

                        <div class="mb-3">Select a date range of the nominations to add to this quarter.</div>
                        <div>
                            <div class="form-group row">
                                <label class="col-sm-3 col-md-2 col-lg-1 control-label">From Date:</label>
                                <div class="col-sm-3 col-md-4 col-lg-3">
                                    <b-input-group size="sm">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="calendar"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-select :options="monthList" v-model="selMonthFrom">
                                            <!--<template v-slot:first>
                                        <b-form-select-option :value="null">-- All Periods --</b-form-select-option>
                                    </template>-->
                                        </b-form-select>
                                    </b-input-group>
                                </div>
                                <label class="col-sm-3 col-md-2 col-lg-1 control-label">To Date:</label>
                                <div class="col-sm-3 col-md-4 col-lg-3">
                                    <b-input-group size="sm">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="calendar"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-select :options="monthList" v-model="selMonthTo">
                                            <!--<template v-slot:first>
                                        <b-form-select-option :value="null">-- All Periods --</b-form-select-option>
                                    </template>-->
                                        </b-form-select>
                                    </b-input-group>
                                </div>
                            </div>

                            <div class="row d-print-none">
                                <div class="col-sm-3 col-md-2 col-lg-1"></div>
                                <div class="col-sm-7 col-md-7">
                                    <b-button @click="loadNominations()" variant="primary">Load Nominations</b-button>
                                </div>
                            </div>
                        </div>

                        <div v-if="report.length!=0">
                            <hr />
                            <div class="mb-3">
                                Define a new quarter for the Quarterly Awards. The most recent quarter is: <b>{{lastQuarterDesc}}</b>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 col-md-2 col-lg-1 control-label">Quarter:</label>
                                <div class="col-sm-3 col-md-4 col-lg-3">
                                    <b-input-group size="sm" id="quarterYearGrp" label-for="quarterYearTxt">
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="calendar"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-select :options="newQuartersList" v-model="selQuarter" />
                                    </b-input-group>
                                </div>
                            </div>

                            <div class="row d-print-none">
                                <div class="col-sm-3 col-md-2 col-lg-1"></div>
                                <div class="col-sm-7 col-md-7">
                                    <b-button type="submit" variant="primary">Create New Quarter</b-button>
                                </div>
                            </div>

                        </div>
                    </b-form>

                </div>
            </div>

            <div v-if="hasRunOnce && !isLoading" class="mt-4"><i>Nominations that would be defined in the new Quarter:</i></div>
            <table v-if="hasRunOnce && !isLoading" class="table table-borderless" style="font-size:0.8rem">

                <tbody v-for="f in report" :key="f._rowNum">
                    <tr v-if="f.quarterDescription != ''">
                        <td colspan="4" style="background-color:yellow">Nomination already allocated to Q{{f.quarterDescription}}</td>
                    </tr>

                    <tr>
                        <td><b>Ref:</b></td>
                        <td>{{ f.nomSerialNum + '/' + f.nomId }} - {{ f.dateCreated.sjToDate('d MMM yyyy HH:mm') }}</td>
                        <td><b>Review By:</b></td>
                        <td>{{ f.reviewByMemberNumber + ' - ' + f.reviewByMember + ' ' + f.reviewByDivision }}</td>
                    </tr>
                    <tr>
                        <td><b>Nominee:</b></td>
                        <td>{{ f.nomineeMemberNumber + ' - ' + f.nomineeMember + ' ' + f.nomineeDivision }}</td>
                        <td><b>Rating:</b></td>
                        <td>{{ f.reviewRating + ' / 7' }}</td>
                    </tr>
                    <tr>
                        <td><b>Nominated for:</b></td>
                        <td>{{ f.nomCat }}</td>
                        <td><b>Points:</b></td>
                        <td>{{ f.reviewPointsValue }}</td>
                    </tr>
                    <tr>
                        <td><b>Reason:</b></td>
                        <td class="preline">{{ f.reason }}</td>
                        <td><b>Quarterly Motivation:</b></td>
                        <td class="preline">{{ f.quarterlyMotivation }}</td>
                    </tr>
                    <tr>
                        <td><b>Nominated By:</b></td>
                        <td>{{  f.byMemberNumber + ' - ' + f.byMember + ' ' + f.byDivision }}</td>
                    </tr>
                    <tr>
                        <td colspan="4"><hr /></td>
                    </tr>
                </tbody>


            </table>

            <div v-if="isLoading"><i>Loading...</i></div>
            <div v-if="hasRunOnce && !isLoading && report.length==0"><i>No Results</i></div>

        </section>


        <!-- ************************************************************************************************************************************ -->
        <!-- DEFAULT  -->


        <section v-if="mode===''">
            <div class="card card-default" style="min-width:420px">
                <div class="card-header">
                    <div class="row">
                        <div class="col-sm-6 font-weight-bold">
                            <h5>Quarterly Award Summary</h5>
                        </div>

                        <div class="col-sm-1">

                        </div>
                        <div class="col-sm-5 text-right">
                            <b-button class="d-print-none mr-2" size="sm" @click.prevent="$router.push('/reportquarterlyawards')">Back</b-button>
                            <b-button class="d-print-none mr-2" size="sm" @click.prevent="showNewQuarterForm">Create a new quarter</b-button>
                            <b-button class="d-print-none mr-2" size="sm" @click.prevent="windowPrint" :disabled="report.length==0">Print</b-button>
                            <b-button class="d-print-none" size="sm" @click.prevent="exportToCSV" :disabled="report.length==0">Export to CSV</b-button>
                        </div>
                    </div>

                </div>
                <div class="card-body">

                    <div class="form-group row">
                        <label class="col-sm-3 col-md-2 col-lg-1 control-label">Quarter:</label>
                        <div class="col-sm-3 col-md-4 col-lg-3">
                            <b-input-group v-if="quartersList && quartersList.length !== 0" size="sm" id="quarterYearGrp" label-for="quarterYearTxt">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="calendar"></b-icon>
                                </b-input-group-prepend>
                                <b-form-select :options="quartersList" v-model="selQuarter" />
                            </b-input-group>
                            <span v-else>No Quarter Periods Defined</span>
                        </div>
                    </div>

                    <div v-if="selQuarter">
                        <div class="row mb-1">
                            <div class="col-sm-3 col-md-2 col-lg-1">Quarter:</div>
                            <div class="col-9 fldValue">
                                {{selQuarter.description}}
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-sm-3 col-md-2 col-lg-1">Date Range:</div>
                            <div class="col-9 fldValue">
                                {{ selQuarter.dateFrom.sjToDate('MMMM yyyy')}} - {{selQuarter.dateTo.sjToDate('MMMM yyyy')}}
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-3 col-md-2 col-lg-1">Status:</div>
                            <div class="col-9 fldValue">
                                {{selQuarter.status}}
                            </div>
                        </div>

                        <div class="row d-print-none" v-if="selQuarter.isDone">
                            <div class="col-sm-3 col-md-2 col-lg-1"></div>
                            <div class="col-sm-7 col-md-7">
                                <b-button @click="loadSummary()" variant="" :disabled="!selQuarter.isDone">Load Quarterly Award Summary</b-button>
                            </div>
                        </div>

                    </div>



                </div>
            </div>

            <table v-if="hasRunOnce && !isLoading" class="table table-borderless" style="font-size:0.8rem">

                <tbody v-for="f in report" :key="f._rowNum">

                    <tr>
                        <td><b>Ref:</b></td>
                        <td>{{ f.ref }}</td>

                        <td><b>Count:</b></td>
                        <td>{{ f.totalNominations }}</td>
                    </tr>
                    <tr>
                        <td><b>Nominee:</b></td>
                        <td>{{ f.nomineeMemberNumber + ' - ' + f.nomineeMember + ' ' + f.nomineeDivision }}</td>
                        <td><b>Average Rating:</b></td>
                        <td>{{ f.reviewRatingAve + ' / 7' }}</td>
                    </tr>
                    <tr>
                        <td><b>Nominated for:</b></td>
                        <td colspan="3">{{ f.nomCatCounts }}</td>
                    </tr>
                    <tr>
                        <td><b>Reason:</b></td>
                        <td class="preline">{{ f.reasonSummary }}</td>
                        <td><b>Quarterly Motivation:</b></td>
                        <td class="preline">{{ f.quarterlyMotivationSummary }}</td>
                    </tr>
                    <tr v-if="!f.detail">
                        <td></td>
                        <td colspan="3"><a class="d-print-none" href="#" @click.prevent="loadDetails(f)">Show Nomination Details...</a></td>
                    </tr>
                    <tr v-else>
                        <td colspan="4">
                            <div class="card card-default" style="min-width:420px">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-sm-6 font-weight-bold">
                                            <h5>Details</h5>
                                        </div>

                                        <div class="col-sm-3 text-right">
                                            <b-button class="d-print-none" size="sm" @click.prevent="f.detail = null">Close</b-button>
                                        </div>
                                    </div>

                                </div>
                                <div class="card-body" style="background-color: #efefef">

                                    <table class="table table-borderless" style="font-size:0.8rem">
                                        <tbody v-for="d in f.detail" :key="d._rowNum">
                                            <tr>
                                                <td colspan="4"><hr /></td>
                                            </tr>
                                            <tr>
                                                <td><b>Ref:</b></td>
                                                <td>{{ d.nomSerialNum + '/' + d.nomId }} - {{ d.dateCreated.sjToDate('d MMM yyyy HH:mm') }}</td>
                                                <td><b>Review By:</b></td>
                                                <td>{{ d.reviewByMemberNumber + ' - ' + d.reviewByMember + ' ' + d.reviewByDivision }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Nominee:</b></td>
                                                <td>{{ d.nomineeMemberNumber + ' - ' + d.nomineeMember + ' ' + d.nomineeDivision }}</td>
                                                <td><b>Rating:</b></td>
                                                <td>{{ d.reviewRating + ' / 7' }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Nominated for:</b></td>
                                                <td>{{ d.nomCat }}</td>
                                                <td><b>Points:</b></td>
                                                <td>{{ d.reviewPointsValue }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Reason:</b></td>
                                                <td class="preline">{{ d.reason }}</td>
                                                <td><b>Quarterly Motivation:</b></td>
                                                <td class="preline">{{ d.quarterlyMotivation }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Nominated By:</b></td>
                                                <td>{{  d.byMemberNumber + ' - ' + d.byMember + ' ' + d.byDivision }}</td>
                                            </tr>
                                        </tbody>


                                    </table>
                                </div>
                            </div>
                        </td>

                    </tr>


                    <tr>
                        <td colspan="4"><hr /></td>
                    </tr>
                </tbody>


            </table>
            <div v-if="isLoading"><i>Loading...</i></div>
            <div v-if="hasRunOnce && !isLoading && report.length==0"><i>No Results</i></div>

            

        </section>
    </div>

   
</template>


